import { useModalsContext } from '../../../../../../../../providers/ModalsProvider/Modals.context.ts';
import { useWorkspaceContext } from '../../../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import { useChatContext } from '../../../../../../Chat.hook.ts';
import { VariablesType } from '../../../../../MessageBar/components/VariablesMenu/VariablesMenu.enum.ts';
import { tVariableMappings } from './MessageBubble.type.ts';

export default function useMessageBubble() {
  const { currentWorkspace } = useWorkspaceContext();
  const { selectedChat } = useChatContext();
  const { selectedLeadForChatModal } = useModalsContext();

  function replaceMessageWithVariable(message?: string): string | undefined {
    if (!message || !selectedChat || !currentWorkspace) return message;

    const variableMappings: tVariableMappings = {
      [VariablesType.NAME]: selectedLeadForChatModal?.name || '',
      [VariablesType.EMAIL]: selectedLeadForChatModal?.email || '',
      [VariablesType.PHONE]: selectedLeadForChatModal?.handle || '',
      [VariablesType.COMPANY]: selectedLeadForChatModal?.company || '',
      [VariablesType.WORKSPACE_NAME]: currentWorkspace.name || '',
    };

    return message.replace(
      /{([^}]+)}/g,
      (_, key: keyof tVariableMappings) => variableMappings[key] || '',
    );
  }

  return {
    replaceMessageWithVariable,
  };
}
